var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40.968,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.121 40.541 C 2.528 40.541 0.427 40.541 0.427 40.541 L 0.427 0.427 C 0.427 0.427 2.528 0.427 5.121 0.427 L 54.624 0.427 C 57.216 0.427 59.318 0.427 59.318 0.427 L 59.318 40.541 C 59.318 40.541 57.216 40.541 54.624 40.541 Z",
    fill: "rgb(31,114,205)",
    strokeWidth: 0.8535483870967742,
    stroke: "rgb(217,217,217)",
    strokeMiterlimit: 3.225806451612903,
    strokeDasharray: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.711 14.51 L 5.121 26.879 L 11.813 26.879 L 12.642 24.907 L 14.539 24.907 L 15.368 26.879 L 22.734 26.879 L 22.734 25.374 L 23.39 26.88 L 27.201 26.88 L 27.857 25.342 L 27.857 26.88 L 43.176 26.88 L 45.038 24.958 L 46.783 26.88 L 54.651 26.895 L 49.043 20.729 L 54.651 14.51 L 46.905 14.51 L 45.091 16.395 L 43.402 14.509 L 26.737 14.509 L 25.306 17.702 L 23.842 14.509 L 17.164 14.509 L 17.164 15.964 L 16.421 14.509 L 10.711 14.509 Z M 33.586 16.266 L 42.383 16.266 L 45.074 19.172 L 47.851 16.266 L 50.542 16.266 L 46.454 20.727 L 50.542 25.137 L 47.729 25.137 L 45.038 22.197 L 42.247 25.137 L 33.586 25.137 Z M 35.759 19.724 L 35.759 18.102 L 41.248 18.102 L 43.643 20.694 L 41.142 23.299 L 35.759 23.299 L 35.759 21.53 L 40.558 21.53 L 40.558 19.724 Z M 12.005 16.266 L 15.268 16.266 L 18.975 24.654 L 18.975 16.266 L 22.548 16.266 L 25.412 22.28 L 28.052 16.266 L 31.607 16.266 L 31.607 25.142 L 29.444 25.142 L 29.426 18.186 L 26.272 25.142 L 24.336 25.142 L 21.165 18.187 L 21.165 25.143 L 16.715 25.143 L 15.871 23.153 L 11.312 23.153 L 10.47 25.141 L 8.086 25.141 L 12.005 16.266 Z M 12.091 21.313 L 13.593 17.768 L 15.093 21.313 L 12.09 21.313 Z",
    fill: "rgb(255,255,255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.2d518f55.svg";
export { ForwardRef as ReactComponent };